import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    dataCrud: (state) => state.dataCrud,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.anxAPxDrugsSchema(),
          apiClient.catPsychoSubstance(),
          apiClient.catAgeInterval(),
          apiClient.catDuration(),
          apiClient.catFrequency(),
          apiClient.catSubstanceHabit(),
          apiClient.catIntensity(),
        ]);
        const [
          schemaRes,
          catPsychoSubstance,
          catAgeInterval,
          catDuration,
          catFrequency,
          catSubstanceHabit,
          catIntensity,
        ] = responses.map((res) => res?.data ?? {});

        const catDurationAdjusted1 = (catDuration.data ?? []).slice(77);
        const catDurationAdjusted2 = (catDuration.data ?? []).slice(100);
        const catDurationAdjusted3 = (catDuration.data ?? []).slice(124);

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.back_drugs_substance_id.items = catPsychoSubstance.data ?? [];
        schema.formCrud.back_drugs_age.items = catAgeInterval.data ?? [];
        schema.formCrud.back_drugs_duration_id.items = catDurationAdjusted2;
        schema.formCrud.back_drugs_frequency_id.items = catFrequency.data ?? [];
        schema.formCrud.back_drugs_substance_habit_id.items = catSubstanceHabit.data ?? [];
        schema.formCrud.back_drugs_consciousness_int.items = catIntensity.data ?? [];
        schema.formCrud.back_drugs_internment_duration_id.items = catDurationAdjusted1;
        schema.formCrud.back_drugs_trp_duration_id.items = catDurationAdjusted3;

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelANxAPxDrugs(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createANxAPxDrugs(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateANxAPxDrugs(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteANxAPxDrugs(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
